var map = {
	"./ar-sa.svg": "366e",
	"./de-de.svg": "c9bf",
	"./en-gb.svg": "6d8a",
	"./fr-fr.svg": "fdd2",
	"./it-it.svg": "8382",
	"./ja-jp.svg": "2064",
	"./ko-kr.svg": "95fb",
	"./nl-nl.svg": "2dc3",
	"./pl-pl.svg": "620a",
	"./ru-ru.svg": "1852c",
	"./th-th.svg": "f4ac",
	"./tr-tr.svg": "7f21",
	"./uk-ua.svg": "0fd6",
	"./zh-cn.svg": "3153",
	"./zh-tw.svg": "0a2c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "757f";